import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Shared top-bar layout for the analysis screens (mosaic + microscope). A pure presentational
 * shell: it owns the three-zone row (start / center / end), the toolbar surface, and the
 * breadcrumb theming — but projects each screen's own content into the zones, so every screen
 * keeps its facade and its buttons.
 *
 * - `barStart`  → the navigation breadcrumb (shared component, projected by each screen).
 * - `barCenter` → screen-specific actions (mosaic's layout toggles, microscope's tools).
 * - `barEnd`    → screen-specific buttons (save/close/…).
 *
 * `variant` adapts the same bar to both layout models:
 * - `inline`  → an in-flow row (mosaic: the columns sit below it).
 * - `overlay` → a full-width floating bar across the top of a full-bleed viewer (microscope),
 *   transparent to pointer events except over its own controls.
 */
@Component({
  selector: 'ts-analysis-top-bar',
  templateUrl: './analysis-top-bar.component.html',
  styleUrls: ['./analysis-top-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnalysisTopBarComponent {
  @Input() public variant: 'inline' | 'overlay' = 'inline';
}
